import { render } from "./SettingArea.vue?vue&type=template&id=49d3e44e"
import script from "./SettingArea.vue?vue&type=script&lang=js"
export * from "./SettingArea.vue?vue&type=script&lang=js"

import "./SettingArea.vue?vue&type=style&index=0&id=49d3e44e&lang=css"

import exportComponent from "/mnt/d/Projects/santanu-main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__